import { ReactComponent as LogoIcon } from 'assets/icons/logo.svg';
import { clsx } from 'clsx';

import type { ReactElement } from 'react';
import type IAiChatLoader from '../interfaces/IAiChatLoader';

import styles from '../sass/AiChatLoader.module.scss';

/**
 * Shown while a reply is still being written.
 *
 * A copy of `DotsLoader` rather than a use of it: this one belongs to the chat, so it can be given
 * a look of its own without disturbing the loader the rest of the app shows.
 */
function AiChatLoader({ className, spinning }: IAiChatLoader): ReactElement {
  return (
    <div className={clsx(styles.root, className, spinning && styles.spinning)}>
      <LogoIcon />
    </div>
  );
}

export default AiChatLoader;
